import { render, staticRenderFns } from "./GroupPricingAndDoseDistribution.vue?vue&type=template&id=399c5ddb&"
import script from "./GroupPricingAndDoseDistribution.vue?vue&type=script&lang=js&"
export * from "./GroupPricingAndDoseDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports